import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import ModalPortal from '../ModalPortal';
import { OPEN_START, CLOSE_START } from '../../modules/status';

// Need class in order to use componentDidUpdate and
// provide focus back to trigger when modal is closed
class Modal extends PureComponent {
  componentDidUpdate() {
    const { status } = this.props;

    if (status === CLOSE_START && this.triggerEl) {
      this.triggerEl.focus();
    }
  }

  onClickTrigger = (e) => {
    const { id, setStatus } = this.props;
    setStatus({ id, status: OPEN_START });
    this.triggerEl = e.target;
  }

  render() {
    const {
      triggerComponent,
      children,
      id,
      setStatus,
      closeIconSrc,
      status,
      contentLabel,
      appElementSelector,
      aria,
      transition,
      showCloseButton,
      modalContentExtraClass,
      modalContentInnerExtraClass,
      hasGrid,
    } = this.props;

    return (
      <Fragment>
        {
          triggerComponent && React.cloneElement(triggerComponent, {
            onClick: this.onClickTrigger,
          })
        }
        <ModalPortal
          setStatus={setStatus}
          id={id}
          status={status}
          closeIconSrc={closeIconSrc}
          contentLabel={contentLabel}
          appElementSelector={appElementSelector}
          aria={aria}
          transition={transition}
          showCloseButton={showCloseButton}
          modalContentExtraClass={modalContentExtraClass}
          modalContentInnerExtraClass={modalContentInnerExtraClass}
          hasGrid={hasGrid}
        >
          { children }
        </ModalPortal>
      </Fragment>
    );
  }
}

Modal.propTypes = {
  triggerComponent: PropTypes.node,
  children: PropTypes.node.isRequired,
  id: PropTypes.string.isRequired,
  setStatus: PropTypes.func.isRequired,
  closeIconSrc: PropTypes.string,
  status: PropTypes.string,
  contentLabel: PropTypes.string,
  appElementSelector: PropTypes.string.isRequired,
  aria: PropTypes.objectOf(PropTypes.string),
  transition: PropTypes.oneOf(['fade', 'slide']),
  showCloseButton: PropTypes.bool,
  modalContentExtraClass: PropTypes.string,
  modalContentInnerExtraClass: PropTypes.string,
  hasGrid: PropTypes.bool,
};

export default Modal;
